import React from 'react'

const Pokemon = ({id, image, name, type }) => {
    const style = type + " thumb-container";
    return (
        <div className={style}>
            <div className="number"><small>Index No. : {id}</small></div>
            <img src={image} alt={name} />
            <div className="detail-wrapper">
                <h3>{name}</h3>
                <small>Type of Pokemon : {type}</small>
            </div>
        </div>
    )
}

export default Pokemon;